module.exports = "pegasus_template/assets/blocks/social-1-theme4.png";